import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  d: "M1.459.121l6.402 5.603c.093.08.139.172.139.276 0 .105-.046.197-.139.277L1.46 11.88c-.092.08-.199.12-.317.12-.119 0-.225-.04-.316-.12l-.687-.602c-.093-.08-.139-.172-.139-.277 0-.104.046-.195.139-.276L5.539 6 .14 1.275C.046 1.195.002 1.103.002.998c0-.104.044-.195.137-.276l.687-.6C.917.04 1.023 0 1.142 0c.118.001.225.042.317.121z"
}), 'ArrowRight', {
  viewBox: '0 0 8 12'
});